export const version = '2.5.0'
export const publishedDate = '2023-06-25'
